import { InputBase, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/system';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
      margin: theme.spacing(0.5),
      border: 0,
      '&.Mui-disabled': {
        border: 0,
      },
      '&:not(:first-of-type)': {
        borderRadius: theme.shape.borderRadius,
      },
      '&:first-of-type': {
        borderRadius: theme.shape.borderRadius,
      },
    },
  }),
);

export const StyledInput = styled(InputBase)(({ theme }) => ({
  // '& .MuiInputBase-root': {
  //   backgroundColor: theme.palette.common.white,
  // }
  '& .MuiInputBase-input': {
    boxSizing: 'border-box',
    position: 'relative',
    height: 45,
    padding: '10px 26px 10px 12px',
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    fontSize: 16,
    '&:focus': {
      borderRadius: 4,
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
  },
  '&.Mui-error': {
    '& .MuiInputBase-input': {
      borderRadius: 4,
      borderColor: theme.palette.error.main,
      borderWidth: 2,
    },
  },
}));
